import { render, staticRenderFns } from "./quill.vue?vue&type=template&id=1a4c370e&scoped=true"
import script from "./quill.vue?vue&type=script&lang=js"
export * from "./quill.vue?vue&type=script&lang=js"
import style0 from "./quill.vue?vue&type=style&index=0&id=1a4c370e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4c370e",
  null
  
)

export default component.exports